import { render, staticRenderFns } from "./DynamicCreate.vue?vue&type=template&id=a99cd066&scoped=true&"
import script from "./DynamicCreate.vue?vue&type=script&lang=js&"
export * from "./DynamicCreate.vue?vue&type=script&lang=js&"
import style0 from "./DynamicCreate.vue?vue&type=style&index=0&id=a99cd066&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99cd066",
  null
  
)

export default component.exports